import { FC } from 'react';
import { ServiceHomeInternetSliceItem } from '@/store/slice/home-internet.slice';
import { TariffService } from '@/shared/ui-kit/tariff-service';
import { ONLINE_CINEMA_LOGOS, ONLINE_CINEMAS_TITLE } from '@/modules/tariff/shared/constants';
import styles from './basket-online-cinemas.module.scss';

interface BasketOnlineCinemasProps {
  data?: ServiceHomeInternetSliceItem[];
}

export const BasketOnlineCinemas: FC<BasketOnlineCinemasProps> = ({ data }) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>{ONLINE_CINEMAS_TITLE}</div>
      {data?.map((item, index) => (
        <TariffService
          key={`${item.localized_name}-${item.id}`}
          title={item.localized_name}
          logo={ONLINE_CINEMA_LOGOS[item?.name as keyof typeof ONLINE_CINEMA_LOGOS]}
          onChange={() => {}}
          servicePrice={index === 0 ? item.prices.promotion_price || 0 : item.prices.mono_price || 0}
          oldPrice={index === 0 ? item.prices.mono_price : null}
          period={index === 0 ? item.promotion_period : null}
          isKinomaniya
          added
        />
      ))}
    </div>
  );
};
